import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type {
  PartnerStatus,
  PartnerTier,
  PartnerType,
} from "@colab/shared";

// Phase 7 sub-bucket 10 — admin partners list with attribution-aggregate
// counts. Distinct from `usePartners()` (the Phase 6 raw partners list)
// because admin renders deal_count + intro_count chips per row.
export type AdminPartnerListRow = {
  id: string;
  company_name: string;
  partner_type: PartnerType;
  // Legacy enum mirror (nullable since 0085). Tier display is assignment-driven
  // off `tier_id`; `tier` is retained for any legacy consumers.
  tier: PartnerTier | null;
  tier_id: string | null;
  status: PartnerStatus;
  region: string | null;
  primary_contact_email: string | null;
  hubspot_company_id: string | null;
  hubspot_partner_record_id: string | null;
  created_at: string;
  updated_at: string;
  deal_count: number;
  intro_count: number;
};

export function useAdminPartnersList(opts: { enabled?: boolean } = {}) {
  return useQuery<AdminPartnerListRow[], ApiClientError>({
    queryKey: queryKeys.admin.partners.list(),
    queryFn: () => apiFetch<AdminPartnerListRow[]>("/admin/partners"),
    enabled: opts.enabled ?? true,
  });
}
